import { StripeStatus } from '@/types/integrations.types';
import { ChannelSettingsState } from './types';

export const initialState: ChannelSettingsState = {
  bccEmails: null,
  projectAlertEmails: null,
  redirects: null,
  showEditChannelDetailsModal: false,
  showEditPrimaryContactModal: false,
  showEditEmailSettingsModal: false,
  showRedirectModal: false,
  apiKeys: null,
  loadingApiKeys: false,
  channelInstances: null,
  trayUser: null,
  solutions: null,
  solutionsMapped: null,
  solutionInstances: null,
  instanceToCreate: null,
  oauthIntegration: null,
  stripe: {
    loading: false,
    status: StripeStatus.none,
    contact: null,
    setting_contact: false,
  },
  showStripeModal: false,
  showSelectIntegrationModal: false,
  showUpsertIntegrationModal: false,
  integrationNameToAdd: null,
  showHiveModal: false,
  showKollectiveModal: false,
  inboundIntegrationToEdit: null,
};
